import CONFIGURACIONES from "../../../../util/constants";
import OWASP from "../../../../util/owasp";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";

import { Http } from "../../../../helpers/Http";
import { useLocation, useOutletContext } from "react-router-dom";
import { useMemo } from "react";

const MantConceptoPagoCaja = ({MySwal, mant, idEdit, createData, updateData, closeSection, idRef, setIdRef, endPointShow, setEndPointUpdate, showCreate, showEdit, init, metodosPago}) => {
    const location = useLocation();
    const { showSpinnerLoader } = useOutletContext();

    const { register, handleSubmit, reset, getValues, setValue, formState: { errors } } = useForm({mode: "onChange"});
    const [title, setTitle] = useState(CONFIGURACIONES.INIT.STRING);

    const [valueTipo, setValueTipo] = useState(CONFIGURACIONES.INIT.STRING);
    const [arrMetodos, setArrMetodos] = useState(CONFIGURACIONES.INIT.ARRAY);

    useEffect(() => {
        reset();
        showSpinnerLoader();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSeg', lastSegment);
        
        if (lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')) {
            init();
            setIdRef((lastSegment === 'new'? CONFIGURACIONES.INIT.ID_EDIT:lastSegment));
            showData((lastSegment === 'new'? CONFIGURACIONES.INIT.ID_EDIT:lastSegment));
            setTitle((lastSegment === 'new')? `Creando ${mant}`:`Editando ${mant}`);
        }

    }, [location.pathname]);

    const onSubmit1 = (form) => {
        if (arrMetodos.length == 0) {  
            MySwal.fire({
                title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                html: `<small>Por favor indique <strong class="text-danger">MÉTODOS DE PAGO</strong></small>`,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
                cancelButtonColor: "#f62d51",
                confirmButtonColor: "#2962FF"
            });
            return; 
        }
        
        let data = {
            'tipoCaja': form.tipoCaja,
            'nombre': form.nombre,
            'tipo': form.tipo,
            'metodosPago': arrMetodos
        }
        // console.log('form', form);
        if (idRef === CONFIGURACIONES.INIT.ID_EDIT) {
            createData(data);
        } else {
            updateData(data);
        }
    };

    const changeMetodo = (id, check) => {
        setArrMetodos((prev) => {
            if (check) {
                return [...new Set([...prev, id])];
            } else {
                return prev.filter((idx) => idx !== id);
            }
        });
    };

    const showData = async (ref) => {
        console.log('ref', ref);
        
        if (ref !== CONFIGURACIONES.INIT.ID_EDIT) {
            console.log('entras...', endPointShow);
            if (endPointShow === CONFIGURACIONES.INIT.STRING || !showEdit) { closeSection(); }
            
            await Http().get(endPointShow)
            .then(async (rpta) => {
                if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                    // setLinks(rpta.data.links);
                    setEndPointUpdate(rpta.data.links.find(link => link.rel === CONFIGURACIONES.REFS.UPDATE)?.href || null);
                    // let cmpLink = rpta.data.links.find(link => link.rel === CONFIGURACIONES.INIT.HREF_LOGS);
                    // console.log('cmpLink', cmpLink);
                    // await loadLogData(cmpLink?.href);
                    loadForm(rpta.data);
                }
            });
        } else {
            if (!showCreate) { closeSection(); }
        }
    };


    const loadForm = (object) => {
        setValue('tipoCaja', object.tipoCaja);
        setValue('nombre', object.nombre);
        setValue('tipo', object.tipo);
        setValueTipo(object.tipo);
        setArrMetodos(object.detalles);
    };

    const metodosPagoFilter = useMemo(() => {
        return metodosPago.filter(item => item.tipo == valueTipo);
    }, [valueTipo]);

    return (
        <>
        { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
            <div className="card-content">
                <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                    <div className="row">
                        <div className="col-xs-12 col-md-11"> 
                            <h5 className="card-title font-weight-bold">{title}</h5>
                            <div className="row">
                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="tipoCaja" className="control-label col-form-label">Tipo de Caja <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("tipoCaja", {
                                                required: OWASP.REQUIRED
                                            })} className="form-control" id="tipoCaja" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                            {
                                                CONFIGURACIONES.INIT.LIST.TIPOS_CAJA.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.tipoCaja && errors.tipoCaja.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="tipo" className="control-label col-form-label">Tipo de Movimiento <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("tipo", {
                                                required: OWASP.REQUIRED,
                                                onChange: (e) => {
                                                    setValueTipo(e.target.value);
                                                    setArrMetodos(CONFIGURACIONES.INIT.ARRAY);
                                                }
                                            })} className="form-control" id="tipo" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                            {
                                                CONFIGURACIONES.INIT.LIST.TIPOS_MOVIMIENTO_CAJA.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.tipo && errors.tipo.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="nombre" className="control-label col-form-label">Nombre <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("nombre", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.GENERAL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="nombre" placeholder="" />
                                        <small className="invalid-feedback"> { errors.nombre && errors.nombre.message }</small>           
                                    </div>
                                </div>
                            </div>

                            <hr className="bg-success pb-1" />
                            <div className="row">
                                <div className="col-sm-12">        
                                    <h5 className="text-muted">Métodos de Pago</h5>
                                </div>
                            </div>

                            <div className="row my-2">
                                {metodosPagoFilter.length > 0? (
                                    metodosPagoFilter.map((item) => (
                                    <div className="col-sm-12 col-md-3" key={`chk_${item.id}`}>
                                        <div className="form-group">
                                            <div className="custom-control custom-checkbox">
                                                <input type="checkbox" className="custom-control-input" id={`chk_${item.id}`} 
                                                    onChange={(e) => {changeMetodo(item.id, e.target.checked)}}
                                                    checked={arrMetodos.includes(item.id)}
                                                />
                                                <label className="custom-control-label" htmlFor={`chk_${item.id}`}>{item.nombre}<br/> 
                                                            <small className="text-muted">[{item.aplicadoANombre}]</small></label>
                                            </div>
                                         </div>
                                    </div>
                                    ))
                                ): (
                                    <div className="col-sm-12">
                                        <span className="text-danger">No se encontraron Métodos de Pago Disponibles.</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                       
                    <div className="action-form mt-1 d-flex justify-content-start">
                        <div className="form-group mb-0 text-left">
                            <WaveButton type="button" onClick={ closeSection } className="btn btn-sm btn-outline-danger waves-effect">
                                <i className="mdi mdi-arrow-left"></i> Descartar
                            </WaveButton>
                            { idRef == CONFIGURACIONES.INIT.ID_EDIT && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Guardar
                            </WaveButton>}

                            { idRef > CONFIGURACIONES.INIT.NUMBER && <WaveButton type="submit" className="btn btn-sm btn-info waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Modificar
                            </WaveButton>}
                        </div>
                    </div>
                </form>
            </div>
            </>
        }
        </>
    )
}
export default MantConceptoPagoCaja;